import { Button, Grid, Header, Table } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import '../../../../app/common/MediaQuery/responsive-view-page.css';
import { useStore } from '../../../../app/stores/store';
import { Link } from 'react-router-dom';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';
import { useEffect } from 'react';
 
const NFAIRestoKeys = [
  "Data Management",
  "Base Grade",
  "Reel Analysis",
  "Restoration",
  "NFHM Reel Analysis QC",
  "NFHM Restoration QC",
  "NFHM Color Grading QC",
  "AV Sync",
  "Encrypted QC Report",
  "Open QC Report",
  "Deliverables QC Report",
  "DPX QC Report",
  "DSM QC Report",
  "LTO QC Report",
  "LTO Label Creation",
  "Consolidated Restoration Report and Quality Sign Off"
];

function HistoryDetailsHeader() {
  const {
    userStore: { user },
    commonStore,
    viewStore: {activeOrder,itemDetails,HandleParentLinkStatus,NFAIReportParentLinkStatus },
    activityStore: { selectedActivity }
  } = useStore();
  const getActionerName = (key: string) => {
  for (const task of activeOrder.tasks || []) {
    for (const subTask of task.subTasks || []) {
      if (subTask.subTaskName === key) {
        return subTask.actionerName ?? 'No User';
      }
    }
   }
  return 'No User';
  };
  useEffect(() => {
  if (!selectedActivity?.id) return;
  }, [selectedActivity?.id]);
  useEffect(() => {
    if(!commonStore.NFAIReportCustomer) return;
    HandleParentLinkStatus(selectedActivity?.id)
     // eslint-disable-next-line
  },[])
  return (
    <>
      <Grid className="lg-screen-metadata">
        <Grid.Row>
          <Grid.Column>
            <Header
              as="h2"
              content={itemDetails?.title}
            style={{
                textAlign:
                  user?.customerName === 'NFAI' &&
                  window.innerWidth < 1025 &&
                  window.innerWidth > 1020
                    ? 'center'
                    : 'auto',
              }}
            />
          </Grid.Column>
        </Grid.Row>
        {!commonStore.filterModeTwo?.includes('AVLAVB17') ? (
          <div className="audio-player">
            <AudioPlayer
              // src="../assets/queenelizabethparliamentopen2019.mp3"
              src="../assets/Tabla_Baya_Sample_audio.mp3"
              className={
                commonStore.filterModeZero.includes('AVLAVB17')
                  ? 'component-isDisabled'
                  : ''
              }
            />
          </div>
        ) : (
          <>
            {(user?.customerName !== 'NFAI' ||
              window.innerWidth > 1025 ||
              window.innerWidth < 1020) && (
              <Grid.Row columns={4}>
                {itemDetails?.element && (
                  <Grid.Column>
                    <Header
                      as="h5"
                      content={`${(userLanguage[0].HistoryHeader.HH01 as any)?.[`${commonStore.language.key}`] } : ${itemDetails.element}`}
                    />
                  </Grid.Column>
                )}
                {itemDetails?.type && (
                  <Grid.Column>
                    <Header
                      as="h5"
                      content={`${(userLanguage[0].HistoryHeader.HH02 as any)?.[`${commonStore.language.key}`]}: ${itemDetails?.type}`}
                    />
                  </Grid.Column>
                )}
                <Grid.Column>
                  <Header
                    as="h5"
                    content={
                      user?.customerName === 'LVP CMS - AM'
                        ? `Asset In Room: ${itemDetails?.asset_In_Vault}`
                        :`${(userLanguage[0].HistoryHeader.HH03 as any)?.[`${commonStore.language.key}`]}: ${itemDetails?.asset_In_Vault}`
                    }
                  />
                </Grid.Column>
                {user?.customerName === 'RAI' &&
                  itemDetails.parent?.split('/')?.[1] && (
                    <Grid.Column>
                      <Header as="h5" style={{ display: 'inline' }}>
                        Parent:{' '}
                      </Header>
                      <a
                        href={itemDetails.parent?.split('/')?.[0]}
                        style={{ fontWeight: 'bold' }}
                      >
                        {itemDetails.parent?.split('/')?.[1]}
                      </a>
                    </Grid.Column>
                  )}
                {user?.customerName !== 'RAI' && (
                  <Grid.Column className={ (NFAIReportParentLinkStatus === 'Disable' && commonStore.NFAIReportCustomer) ? 'component-isDisabled' : ''}>
                    <Header as="h5" style={{ display: 'inline' }}>
                    {(userLanguage[0].HistoryHeader.HH04 as any)?.[`${commonStore.language.key}`]}:{' '}
                    </Header>
                    {itemDetails.parent?.split('/')?.[1] ? (
                      <a
                        href={itemDetails.parent?.split('/')?.[0]}
                        style={{ fontWeight: 'bold' }}
                      >
                        {itemDetails.parent?.split('/')?.[1]}
                      </a>
                    ) : (
                      <b>null</b>
                    )}
                  </Grid.Column>
                )}
              </Grid.Row>
            )}
 
            <Grid.Row columns={4}>
              <Grid.Column>
                <Header
                  as="h5"
                  content={`${(userLanguage[0].HistoryHeader.HH05 as any)?.[`${commonStore.language.key}`]}: ${itemDetails?.current_task}`}
                />
              </Grid.Column>
              <Grid.Column>
                <Header
                  as="h5"
                  content={`${(userLanguage[0].HistoryHeader.HH06 as any)?.[`${commonStore.language.key}`]}: ${itemDetails?.current_subtask}`}
                />
              </Grid.Column>
              <Grid.Column>
                <Header
                  as="h5"
                  content={`${(userLanguage[0].HistoryHeader.HH07 as any)?.[`${commonStore.language.key}`]}: ${itemDetails?.status}`}
                />
              </Grid.Column>
              <Grid.Column>
                {user?.customerName === 'NFAI' &&
                  window.innerWidth < 1025 &&
                  window.innerWidth > 1020 && (
                    <Button
                      className="adh-button nfai"
                      as={Link}
                      to={`/manage/${itemDetails.id}`}
                      color="orange"
                      disabled={commonStore.filterModeZero?.includes(
                        'AVLAVB01',
                      )}
                      // style={{marginTop: '-10px'!important }}
                      //Manage Asset
                    >
                      {
                        (
                          userLanguage[0].AssetViewItemLevelAllAssetsView
                            .AVLAVB01 as any
                        )?.[`${commonStore.language.key}`]
                      }
                    </Button>
                  )}
                {(user?.customerName !== 'NFAI' ||
                      window.innerWidth > 1025 ||
                      window.innerWidth < 1020) && (
                      <Header
                        as="h5"
                        content={`${(userLanguage[0].HistoryHeader.HH08 as any)?.[`${commonStore.language.key}`]}: ${itemDetails?.current_user}`}
                      />
                    )}
              </Grid.Column>
             {user?.customerName === "NFAIReport" && (
                <>
                  {NFAIRestoKeys.map((key) => (
                    <Grid.Column key={key} style={{ margin: '12px 0px' }}>
                      <Header
                        as="h5"
                        content={`${key}:  ${getActionerName(key)} `}
                      />
                    </Grid.Column>
                  ))}
                </>
              )}
            </Grid.Row>
          </>
        )}
      </Grid>
      <Grid className="sm-screen-metadata">
        <Table definition>
          <Table.Body>
            <Table.Row>
              <Table.Cell width={7}>
                <strong>Title</strong>
              </Table.Cell>
              <Table.Cell>{itemDetails?.title}</Table.Cell>
            </Table.Row>
            {/* <Table.Row>
              <Table.Cell width={7}>
                <strong>Language</strong>
              </Table.Cell>
              <Table.Cell>{activity?.language}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                <strong>Year</strong>
              </Table.Cell>
              <Table.Cell>{activity?.year}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                <strong>Origin</strong>
              </Table.Cell>
              <Table.Cell>{activity?.originIndia}</Table.Cell>
            </Table.Row> */}
            <Table.Row>
              <Table.Cell width={7}>
                <strong>Current Task</strong>
              </Table.Cell>
              <Table.Cell>{itemDetails?.current_task}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                <strong>Current SubTask</strong>
              </Table.Cell>
              <Table.Cell>{itemDetails?.current_subtask}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                <strong>Workflow Status</strong>
              </Table.Cell>
              <Table.Cell>{itemDetails?.status}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                <strong>Current User</strong>
              </Table.Cell>
              <Table.Cell>{itemDetails?.current_user}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                <strong>
                  {user?.customerName === 'LVP CMS - AM'
                    ? 'Asset In Room'
                    : 'Asset In Vault'}
                </strong>
              </Table.Cell>
              <Table.Cell>{itemDetails?.asset_In_Vault}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Grid>
    </>
  );
}
 
export default observer(HistoryDetailsHeader);